<template>
    <div v-if="author.id" class="container content-space-b-1">
        <div class="row justify-content-center">
            <div class="col mx-3 col-lg-8 card">
                <div class="card-header px-0 py-2 p-lg-4 border-bottom">
                    <div class="d-flex align-items-center">
                        <prismic-image :img="author.data.avatar" w="60" h="60" />
                        <div class="d-flex flex-column justify-content-center pt-2 ps-2">
                            <nuxt-link :to="$prismic.linkResolver(author)">
                                <h4 class="fs-5 mb-0">{{ $prismic.asText(author.data.name) }}</h4>
                            </nuxt-link>
                            <span class="fs-6">
                                {{ 
                                    $translate('last_updated', 'Senast uppdaterad {date}')
                                        .replace('{date}', $format.date(lastPublicationDate)) 
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body px-0 py-2 p-lg-4">
                    <p class="m-0">{{ $prismic.asText(author.data.bio) }}</p>

                    <div v-if="tooltipItems.length" class="d-flex column-gap-3 gap-2 mt-4 flex-wrap">
                        <div 
                            v-for="(item, index) in tooltipItems" 
                            :key="index" 
                            v-tooltip="{
                                content: item.text,
                                classes: 'text-start'
                            }"
                            class="btn d-flex gap-2 align-items-center px-3 py-1 bg-soft-secondary fw-light text-dark cursor-pointer"
                        >
                            <span class="fs-6 text-decoration-underline">
                                {{ item.buttonText }}
                            </span>
                            <prismic-image 
                                v-if="item.iconImage && item.iconImage.url"
                                :img="item.iconImage"
                                class="max-width-100 rounded-1"
                                w="20"
                            />
                            <i 
                                v-else
                                class="bi text-primary fs-5" 
                                :class="item.icon"
                            />
                        </div>
                    </div>

                    <template v-if="hasSources">
                        <h5 class="mt-4 card-title">
                            {{ $translate('sources', 'Källor') }}
                        </h5>
                        <ul class="list-unstyled mb-0">
                            <li 
                                v-for="source in filteredSources" 
                                :key="source"
                            >
                                <a :href="source" target="_blank">
                                    {{ source }}
                                </a>
                            </li>
                        </ul>
                    </template>
                </div>
                <div v-if="editor.data" class="card-footer py-2 px-0 p-md-2 mt-3 border-top">
                    <div class="d-flex align-items-center gap-2">
                        <prismic-image
                            :img="editor.data.avatar" 
                            w="40" 
                            h="40" 
                        />
                        <span class="fs-6">
                            {{ $translate('edited_by', 'Granskad av') }}
                            <nuxt-link :to="$prismic.linkResolver(editor)" class="fw-bold text-dark">
                                {{ $prismic.asText(editor.data.name) }}
                            </nuxt-link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        author: {
            type: Object,
            required: true
        },
        editor: {
            type: Object,
            required: false,
            default: null
        },
        lastPublicationDate: {
            type: String,
            required: true
        },
        sources: {
            type: Array,
            required: true
        }
    },
    computed: {
        filteredSources() {
            return this.sources
                .map(iterator => iterator.source)
                .filter(source => source !== null && source.length > 0)
                .map(source => source.trim());
        },
        hasSources() {
            return this.filteredSources.length > 0;
        },
        tooltipItems() {
            const settings = this.$store.state.settings;
            const howWeOperateText = settings.how_we_operate_text;
            const verifiedInfoText = settings.verified_info_text;
            return [
                {
                    icon: 'bi-question-circle-fill',
                    buttonText: settings.how_we_operate_button_text,
                    text: this.$validateText(howWeOperateText) ? this.$prismic.asHtml(howWeOperateText) : null,
                },
                {
                    icon: 'bi-patch-check-fill',
                    buttonText: settings.verified_info_button_text,
                    text: this.$validateText(verifiedInfoText) ? this.$prismic.asHtml(verifiedInfoText) : null,
                    iconImage: settings.verified_info_icon
                },
            ].filter(item => item.text);
        }
    }
};
</script>